import approvalIcon from "@loot-os/icons/icons/approval";
import { Badge } from "../../../../core/Badge.js";
import { Button } from "../../../../core/Button.js";
import { Icon } from "../../../../core/Icon.js";
import { Panel } from "../../../../core/Panel.js";
import { Text } from "../../../../core/Text.js";
import type { AccountVerificationContent } from "../../accountContent.js";

const BADGE_TONE = {
  neutral: "neutral",
  success: "success",
  warning: "warning",
  danger: "danger",
} as const;

/**
 * Settings → Verification: where identity verification stands, what to know before starting it,
 * and the one button that starts it (identity alone).
 */
export function AccountVerification({
  title,
  description,
  status,
  notes,
  action,
  provider,
}: AccountVerificationContent) {
  return (
    <Panel title={title} description={description}>
      <div className="flex flex-col gap-4 rounded-xl bg-bg-inset p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-3">
          {status.tone === "success" && (
            <Icon icon={approvalIcon} size={20} className="text-status-success" />
          )}
          <Badge tone={BADGE_TONE[status.tone]}>{status.badge}</Badge>
          <Text variant="body-b2" tone={status.tone === "neutral" ? "secondary" : status.tone}>
            {status.text}
          </Text>
        </div>
        {notes.map((note) => (
          <Text key={note} as="p" variant="body-b2" tone="secondary">
            {note}
          </Text>
        ))}
        <div className="flex flex-wrap items-center gap-3">
          <Button
            variant={action.emphasis === "primary" ? "primary" : "secondary"}
            disabled={action.disabled}
            loading={action.pending}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
          <Text variant="body-b3" tone="tertiary">
            {provider}
          </Text>
        </div>
      </div>
    </Panel>
  );
}
